import { render, staticRenderFns } from "./LayByPayment.vue?vue&type=template&id=4bc4aa4e&scoped=true"
import script from "./LayByPayment.vue?vue&type=script&lang=js"
export * from "./LayByPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc4aa4e",
  null
  
)

export default component.exports